<template>
  <div class="text-center py-16">
    <FormattedHeader
      :header="title"
      :subheader="subtitle"
      class="max-w-md mx-auto mb-10 px-4 sm:px-0"
    />
    <div class="flex flex-wrap justify-center">
      <div
        v-for="(item, index) in benefits"
        :key="`benefits-${index}`"
        class="item w-full mb-8 sm:w-1/2 md:w-1/3 flex flex-col items-center px-6 my-2"
      >
        <img :src="item.icon" class="icon flex-shrink-0 w-10 h-10 mb-6" />
        <TypeHeading
          :variant="$options.Typography.Heading.HEADLINE"
          :weight="$options.Typography.Weights.STRONG"
          class="mb-2"
        >
          <p style="min-height: 43px">{{ item.title }}</p>
        </TypeHeading>
        <TypeBody
          :variant="$options.Typography.Body.LARGE"
          :weight="$options.Typography.Weights.REGULAR"
        >
          <p style="max-width: 290px">{{ item.body }}</p>
        </TypeBody>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { TypeBody, TypeHeading, constants } from '@bambeehr/pollen';
import FormattedHeader from './FormattedHeader.vue';

const { Typography } = constants;

export default defineComponent({
  name: 'WhatYouGet',
  Typography,
  components: {
    FormattedHeader,
    TypeBody,
    TypeHeading,
  },
  setup() {
    const title = `What You Get`;
    const subtitle = `Bambee gives you a dedicated HR manager who helps you craft HR policy and understand compliance`;
    const benefits = [
      {
        title: 'Dedicated HR Manager',
        body: 'Not a call center or a hotline, your HR manager is dedicated to you.',
        icon: '/assets/information/benefits/headphones-customer-support-human.svg',
      },
      {
        title: 'In-Depth HR Audit',
        body: 'We audit your current HR business practices and help uncover hidden risks to your business.',
        icon: '/assets/information/benefits/todos-line.svg',
      },
      {
        title: 'Written Policies',
        body: 'We’ll work with you to craft your internal HR policies that fit the way you run your business.',
        icon: '/assets/information/benefits/policies-line.svg',
      },
      {
        title: 'A Powerful Platform',
        body: 'Store documents and company date in a platform designed to help you avoid mistakes',
        icon: '/assets/information/benefits/desktop-monitor-smiley-1.svg',
      },
      {
        title: 'Unbiased Guidance & Coaching',
        body: 'Not a call center or a hotline, your HR manager is dedicated to you.',
        icon: '/assets/information/benefits/strategy.svg',
      },
      {
        title: 'Unlimited HR Support',
        body: 'Available to help by phone, email, or chat. Consider us an extension of your team.',
        icon: '/assets/information/benefits/time-clock-circle-1.svg',
      },
    ];
    return {
      title,
      subtitle,
      benefits,
    };
  },
});
</script>
